export const CLIENT_ID = '159972240635-puqb71bu2n49gbprd395kh4jijhll9d1.apps.googleusercontent.com';
export const REDIRECT_URI = 'https://admin.azad.deloai.com/oauth2callback';
export const API_KEY = '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'; // If needed for other API calls
// export const REDIRECT_URI = 'http://localhost:3000/oauth2callback';
